import { getSignupUrl } from '../../config/surface'

/** Bottom CTA — VistoeraTASK-00262 (previously spec §13, describing the
 * old single-function 商品图片处理 tool). No credit card, no fabricated
 * trial/credit numbers — no Pricing/Plan model this phase, a single
 * honest line instead of fake Free/Pro/Business tiers. */
export default function CtaSection() {
  return (
    <section className="mkt-section mkt-section-cta">
      <div className="mkt-container">
        <h2>开始搭建你的第一个内容生产 Canvas</h2>
        <p className="mkt-section-sub">现在即可免费注册体验，无需信用卡。</p>
        <a className="mkt-btn mkt-btn-primary mkt-btn-lg" href={getSignupUrl()}>
          免费注册
        </a>
      </div>
    </section>
  )
}
